export function LoadingPage() {
  return (
    <div className="h-full overflow-hidden flex items-center justify-center">
      {/* TODO: Spinner? */}
      Loading...
    </div>
  );
}
